import './Pulsar.css';
import { BrowserRouter as Router} from 'react-router-dom';
import PaginaPrincipal from './PaginaPrincipal';


// Para redear el componente con router para el control por url
function Principal(){
    

    return(
  <Router>
      <PaginaPrincipal />
  </Router>

    )
}


export default Principal;